export default "__VITE_ASSET__TK0IAM10__"